import { asMultiStyleConfig } from '../../../../utils/theme';
export var ErrorBanner = asMultiStyleConfig({
  parts: ['alert', 'errorIcon'],
  baseStyle: {
    alert: {
      borderRadius: 'none',
      backgroundColor: 'red.100',
      border: 'none'
    },
    errorIcon: {
      color: 'red.500'
    }
  }
});